import Service from '../service/Service';
import Cookies from "js-cookie";
const service = new Service();
var countimg = 0;
var countpdf = 0;
var img_flag = false;
var pdf_flag = false;
var file_array = [];
var commentDocUrl = "[]";
var isQuestion = false;

export function showAbuse(e) {
    hideAllAbuse()
    e.target.parentElement.getElementsByClassName('abuse-tooltip')[0].style.display = 'block';
}

export function saveQueActions(status, queId, creaId, queTitle, actionType, isSimilarQue, eleRef) {
    if(navigator.onLine){
        if (actionType == 'abuse') {
            hideAllAbuse();
        }
   
        if (global.ftk != '') {
            if (global.userAry['IsTryingToConceive'] == 1 || (global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length > 0)) {
                // service.showLoader();
                var postData = {
                    "childinfo": global.userAry['childData']['UserChildList'],
                    "question_type": 1,
                    "action_status": status + "",
                    "action_type": actionType,
                    "creater_id": creaId + "",
                    "question_id": queId,
                    "user_type": global.userAry['Sex'],
                    "que_type": "child",
                    "question_title": queTitle,
                    "expecting_dob": global.userAry['expectedDob'],
                    "IsTryingToConceive": global.userAry['IsTryingToConceive']
                }
                
                var url = global.api_ci_url + "Qna/saveQueActions";
                
                service.postServiceCall(url, postData).then((json) => {
                    if (isSimilarQue) {
                        eleRef.reloadSimilarQueData(queId, actionType, status);
                    } else {
                        eleRef.reloadData(queId, 0);
                    }
                    service.hideLoader();
                }).catch((error) => {
                    console.error(error);
                    service.hideLoader();
                });
                return true;
            } else {
                service.showAlert("Please Complete Your Child Profile");
                // window.location.href = '/my-account?URL=' + global.currentURL;
                window.location.href = '/my-account';
                return false;
            }
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

export function saveAnsAction(status, queId, ansId, actionType, eleRef) {
    if(navigator.onLine){
        if (status == 1) {
            if (actionType == 'abuse') {
                hideAllAbuse();
            }
            if (global.ftk != '') {
                if (global.userAry['IsTryingToConceive'] == 1 || (global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length > 0)) {
                    service.showLoader();
                    var postData = {
                        "action_status": status + "",
                        "action_type": actionType,
                        "answer_id": ansId + "",
                        "question_id": queId + "",
                        "userPic": global.userAry['userPhoto'],
                        "userName": global.userAry['userName'],
                        "childArr": global.userAry['childData']['UserChildList'],
                        "userGender": global.userAry['Sex'],
                        "IsTryingToConceive": global.userAry['IsTryingToConceive']
                    }
                    var url = global.api_ci_url + "Qna/saveAnsAction";
                    service.postServiceCall(url, postData).then((json) => {
                        eleRef.reloadData(queId, ansId);
                        // service.hideLoader();
                    }).catch((error) => {
                        console.error(error);
                        service.hideLoader();
                    });
                    return true;
                } else {
                    service.showAlert("Please Complete Your Child Profile");
                    // window.location.href = '/my-account?URL=' + global.currentURL;
                    window.location.href = '/my-account';
                    return false;
                }
            } else {
                service.showAlert("Please Login");
                window.location.href = global.loginUrl + '?URL=' + global.currentURL;
                return false;
            }
        }
    }
    else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

export function getAnswerLikeUsers(count, ansId) {
    if(navigator.onLine){
        service.showLoader();
        var postData = {
            "pagesize": count,
            "pageno": 1,
            "answer_id": ansId
        }
        var url = global.api_ci_url + "Qna/getAnswerLikeUsers";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                let data = json['likedUserInfo'];
                if (data.length > 0) {
                    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = 'LIKES';
                    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = service.getUserListHTML(JSON.stringify(data));
                    document.getElementsByClassName('followers-overlay')[0].style.display = 'block';
                    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
                }
            } else {
                service.closeUserListPopup();
                service.showAlert("Fail");
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

function showFileError(mainClass, msg) {
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.display = "inline-block";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = msg;
    service.hideLoader();
}

function hideFileError(mainClass) {
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "hidden";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.display = "none";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = "";
}

export function postAnswer(eleRef) {
    if(navigator.onLine){
        if (global.ftk != '') {
            if (global.userAry['IsTryingToConceive'] == 1 || (global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length > 0)) {
                service.showLoader();
                let postAnswer = document.getElementById('post_answer_text').value.trim();
                if (!postAnswer || postAnswer == '') {
                    showFileError('addAns-overlay', "Please write your answer");
                    return false;
                } else {
                    hideFileError('addAns-overlay');
                    var postData = {
                        "question_id": document.getElementById('answer_queId').value,
                        "pic_url": global.userAry['userPhoto'],
                        "user_name": global.userAry['userName'],
                        "childinfo": getChildPostAry(global.userAry['childData']['UserChildList']),
                        "docUrls": JSON.parse(commentDocUrl),
                        "answer_type": 0,
                        "question_type": 1,
                        "que_type": "child",
                        "question_creater_id": document.getElementById('answer_queUserId').value,
                        "answer_details": postAnswer,
                        "expecting_dob": global.userAry['expectedDob'],
                        "user_type": global.userAry['Sex'],
                        "qnaUserType": "0",
                        "IsTryingToConceive": global.userAry['IsTryingToConceive']
                    }

                    var url = global.api_ci_url + "Qna/postAnswer";
                    service.postServiceCall(url, postData).then((json) => {
                        if(json.isModerate == 0){
                            service.showAlert("Your answer has been posted successfully!!!");
                            
                            eleRef.reloadData(document.getElementById('answer_queId').value, json.answerId);
                            clearAnswerPopupData();
                            
                            
                            
                        } else {
                            document.getElementsByClassName('addAns-overlay')[0].style.display = "none";
                            document.getElementsByClassName('moderation-overlay')[0].style.display = 'block';
                            clearAnswerPopupData();
                            service.hideLoader();
                        }
                    }).catch((error) => {
                        console.error(error);
                        service.hideLoader();
                    });
                    return true;
                }
            } else {
                service.showAlert("Please Complete Your Child Profile");
                // window.location.href = '/my-account?URL=' + global.currentURL;
                window.location.href = '/my-account';
                return false;
            }
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

export function saveQuestion(childId, eleRef) {
    if(navigator.onLine){
        if (global.ftk != '') {
            let askQuestion = document.getElementById('post_question_text').value.trim();
            if (!askQuestion || askQuestion == '') {
                showFileError('askQuest-overlay', "Please type your question");
                return false;
            } else if (childId == 0) {
                showFileError('askQuest-overlay', "Please select a child");
                return false;
            } else {
                hideFileError('askQuest-overlay');
                service.showLoader();
                if (childId != "all") {
                    let childAry = global.userAry['childData']['UserChildList'].filter(function (item) {
                        return childId == item.ChildId;
                    });
                    var postData = {
                        "childinfo": getChildPostAry(childAry),
                        "question_type": 1,
                        "user_type": global.userAry['Sex'],
                        "que_type": "child",
                        "docUrls": JSON.parse(commentDocUrl),
                        "question_title": askQuestion,
                        "expecting_dob": global.userAry['expectedDob'],
                        "IsTryingToConceive": global.userAry['IsTryingToConceive']
                    }
                } else {
                    var postData = {
                        "childinfo": global.userAry['childData']['UserChildList'],
                        "question_type": 1,
                        "user_type": global.userAry['Sex'],
                        "que_type": "myself",
                        "docUrls": JSON.parse(commentDocUrl),
                        "question_title": askQuestion,
                        "expecting_dob": global.userAry['expectedDob'],
                        "IsTryingToConceive": global.userAry['IsTryingToConceive']
                    }
                }
                var url = global.api_ci_url + "Qna/saveQuestion";
                service.postServiceCall(url, postData).then((json) => {
                    if (json['success'] == "1") {
                        
                        Cookies.set('undermoderation', json['isModerate'], 1);
                        
                        eleRef.setState({ childIdQuePost: 0 });
                        service.showAlert("Question Posted successfully");
                        clearQuestionPopupData(eleRef);
                        if (!eleRef.state.isPisPage) {
                            eleRef.props.history.push("/qna/intentmapping/" + service.replaceSymbols((askQuestion) + '-' + (json['queId'])));
                        } else {
                            service.hideLoader();
                        }
                    }
                    // service.hideLoader();
                }).catch((error) => {
                    console.error(error);
                    service.hideLoader();
                });
                return true;
            }
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

function getChildPostAry(reqAry) {
    let resAry = [];
    for (let c = 0; c < reqAry.length; c++) {
        let obj = {};
        obj['id'] = reqAry[c]['ChildId'];
        obj['gender'] = reqAry[c]['Gender'].toLowerCase();
        obj['childdob'] = reqAry[c]['DOB'];
        resAry.push(obj);
    }
    return resAry;
}

export function cmtFileUpload() {

    var mainClass = 'addAns-overlay';
    if (isQuestion) {
        mainClass = 'askQuest-overlay';
    }
    var fileObj = document.getElementById("fileupload").files[0];
    var fname = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime();
    var file_name = "";
    var apiurl = "";
    if(!fileObj){
        return;
    }
    if(navigator.onLine){
        service.showLoader();
        if ((fileObj.type == "image/jpg" || fileObj.type == "image/jpeg" || fileObj.type == "image/png") && fileObj.size < 2097152) {
            file_name = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime() + ".jpg";
            img_flag = true;
            countimg++;
            apiurl = global.api_ci_url + "Qna/uploadMemoryImage";
        } else if (fileObj.type == "application/pdf" && fileObj.size < 2097152) {
            file_name = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime() + ".pdf";
            pdf_flag = true;
            countpdf++;
            apiurl = global.api_ci_url + "Qna/uploadFilesToCommunity";
        } else {
            // countimg = 0;
            // countpdf = 0;
            apiurl = "";
            showFileError(mainClass, "Only JPEG, JPG, PNG and PDF files allowed of less than 2 MB");
            return;
        }

        if ((img_flag && countimg == 1) || (pdf_flag && countpdf == 1)) {
            hideFileError(mainClass);
            service.postFileServiceCall(apiurl, fileObj, file_name).then((json) => {
                if (json["result"] == 'success') {
                    file_array.push({
                        "url": json["image_url"],
                        "height": 10,
                        "width": 10
                    });
                    commentDocUrl = JSON.stringify(file_array);
                    var fileEle = document.getElementsByClassName(mainClass)[0].getElementsByClassName('uploaded-files-list')[0];
                    if (fileObj.type == "application/pdf") {
                        fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "list-item";
                        fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = fileObj.name;
                        pdf_flag = false;
                    } else {
                        fileEle.getElementsByClassName('cmt-image')[0].style.display = "list-item";
                        fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = fileObj.name;
                        img_flag = false;
                    }
                    
                    document.getElementById("fileupload").value = '';
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.showAlert("Fail");
            
                countimg--;
                img_flag = false;
               
                showFileError(mainClass, "Please select Smaller image");
              
                document.getElementById("fileupload").value = '';
                service.hideLoader();

                return;
                
            });

        } else {
            if(countimg > 1){
                countimg--;
                img_flag = false;
            }
            if(countpdf > 1){
                countpdf--;
                pdf_flag = false;
            }
            showFileError(mainClass, "Only 1 image can be uploaded & only 1 pdf can be uploaded");
            service.hideLoader();
            return;
        }
    } else {
        document.getElementById("fileupload").value = '';
        service.showAlert("Please check internet connection");
    }
}

export function cmtFileDelete(type, key) {
    let mainEle = document.getElementsByClassName("addAns-overlay")[0];
    let mainClass = 'addAns-overlay';
    if (key == "que") {
        mainEle = document.getElementsByClassName("askQuest-overlay")[0];
        mainClass = 'askQuest-overlay';
    }
    hideFileError(mainClass);
    for (var i = 0; i < file_array.length; i++) {
        if (type == 'pdf') {
            if (file_array[i]['url'].split('.').pop() == 'pdf') {
                file_array.splice(i, 1);
            }
        } else {
            if (file_array[i]['url'].split('.').pop() != 'pdf') {
                file_array.splice(i, 1);
            }
        }
    }
    commentDocUrl = JSON.stringify(file_array);
    document.getElementById("fileupload").value = '';
    var fileEle = mainEle.getElementsByClassName('uploaded-files-list')[0];
    if (type == "pdf") {
        countpdf--;
        pdf_flag = false;
        fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "none";
        fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    } else {
        countimg--;
        img_flag = false;
        fileEle.getElementsByClassName('cmt-image')[0].style.display = "none";
        fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    }
}
export function openAnswerPopup(qId, qUserId) {
    if (global.ftk != '') {
        document.getElementById('answer_queId').value = qId;
        document.getElementById('answer_queUserId').value = qUserId;
        document.getElementsByClassName('addAns-overlay')[0].style.display = 'block';
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

function clearAnswerPopupData() {
    document.getElementsByClassName('addAns-overlay')[0].style.display = 'none';
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
    countimg = 0;
    countpdf = 0;
    img_flag = false;
    pdf_flag = false;
    file_array = [];
    commentDocUrl = "[]";
    document.getElementById('post_answer_text').value = '';
    document.getElementById('answer_queId').value = '';
    document.getElementById('answer_queUserId').value = '';
    var fileEle = document.getElementsByClassName('uploaded-files-list')[0];
    fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "none";
    fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    fileEle.getElementsByClassName('cmt-image')[0].style.display = "none";
    fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    hideFileError('addAns-overlay');
}

export function closeAnswerPopup(event) {
    if (event.target.classList.contains('addAns-overlay') || event.target.classList.contains('closeButton')) {
        clearAnswerPopupData();
    }
}

export function openQuestionPopup() {
    if (global.ftk != '') {
        document.getElementsByClassName('askQuest-overlay')[0].style.display = 'block';
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        isQuestion = true;
        let eleAry = document.getElementsByClassName('askqueChild')[0].children;
        if (window.innerWidth < 767) {
            let sWidth = 0;
            for (let a = 0; a < eleAry.length; a++) {
                let margin = 10;
                if ((a + 1) == eleAry.length) {
                    margin = 2;
                }
                sWidth = sWidth + eleAry[a].offsetWidth + margin;
            }
            document.getElementsByClassName('askqueChild')[0].style.width = sWidth + 'px';
        }
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}


function clearQuestionPopupData(eleRef) {
    document.getElementsByClassName('askQuest-overlay')[0] && (document.getElementsByClassName('askQuest-overlay')[0].style.display = 'none');
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
    hideFileError('askQuest-overlay');
    eleRef.setState({similarQueRecomm : []});
    countimg = 0;
    countpdf = 0;
    img_flag = false;
    pdf_flag = false;
    file_array = [];
    commentDocUrl = "[]";
    document.getElementById('post_question_text').value = '';
    
    // eleRef.setState({ childIdQuePost: 0 });

    var fileEle = document.getElementsByClassName('askQuest-overlay')[0];
    fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "none";
    fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    fileEle.getElementsByClassName('cmt-image')[0].style.display = "none";
    fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    isQuestion = false;
}

export function closeQuestionPopup(event, eleRef) {
    if (event.target.classList.contains('askQuest-overlay') || event.target.classList.contains('closeButton')) {
        clearQuestionPopupData(eleRef);
    }
}

export function getChildAge(dob) {
    var now = new Date();
    var yearNow = now.getYear();
    var monthNow = now.getMonth();
    var dateNow = now.getDate();

    var dob = new Date(dob);
    var yearDob = dob.getYear();
    var monthDob = dob.getMonth();
    var dateDob = dob.getDate();

    var age = {};

    var yearAge = yearNow - yearDob;

    if (monthNow >= monthDob) {
        var monthAge = monthNow - monthDob;
    } else {
        yearAge--;
        var monthAge = 12 + monthNow - monthDob;
    }

    if (dateNow >= dateDob) {
        var dateAge = dateNow - dateDob;
    } else {
        monthAge--;
        var dateAge = 31 + dateNow - dateDob;
        if (monthAge < 0) {
            monthAge = 11;
            yearAge--;
        }
    }

    age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
    };

    var ageString = '';
    if (yearAge > 0) {
        if (yearAge > 1) {
            ageString = yearAge + ' yrs old';
        } else {
            ageString = yearAge + ' yr old';
        }
    } else if (yearAge <= 0 && monthAge > 0) {
        if (monthAge > 1) {
            ageString = monthAge + ' months old';
        } else {
            ageString = monthAge + ' month old';
        }
    } else if (yearAge <= 0 && monthAge <= 0 && dateAge > 0) {
        if (dateAge > 1) {
            ageString = dateAge + ' days old';
        } else {
            ageString = dateAge + ' day old';
        }
    }
    return ageString;
}

export function hideAllAbuse() {
    let ary = document.getElementsByClassName('abuse-tooltip');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
}

export function loadReadMore() {
    let readmoreAry = document.getElementsByClassName('readmore_popup');
    for (let i = 0; i < readmoreAry.length; i++) {
        let maxHeight = 80;
        if (readmoreAry[i].classList.contains('que-readmore')) {
            maxHeight = 96;
        }
        let dataId = readmoreAry[i].getAttribute('data-id');
        let divHeight = document.getElementById(dataId).offsetHeight;
        if (divHeight > maxHeight) {
            document.getElementById(dataId).style.height = maxHeight + 'px';
            readmoreAry[i].style.display = "inline-block";
        }
    }
}

export function readMoreClick(event, dataId) {
    if (event.target.innerHTML == "Read More") {
        event.target.innerHTML = "Read Less";
        document.getElementById(dataId).style.height = 'auto';
    } else {
        event.target.innerHTML = "Read More";
        let maxHeight = 80;
        if (document.getElementById(dataId).classList.contains('qmore')) {
            maxHeight = 96;
        }
        document.getElementById(dataId).style.height = maxHeight + 'px';
    }
}

export function domClick(event) {
    if (!event.target.classList.contains('abuse-tooltip') && !event.target.classList.contains('report_abuse') && !event.target.classList.contains('icon3dot')) {
        hideAllAbuse()
    }
    if (event.target.classList.contains('ask-a-que-btn')) {
        openQuestionPopup();
    }
    if (event.target.classList.contains('likelist-follow')) {
        service.followUserAction(1, event.target.getAttribute('data-id'));
    }
    if (event.target.classList.contains('likelist-unfollow')) {
        service.followUserAction(0, event.target.getAttribute('data-id'));
    }
}



// WEBPACK FOOTER //
// src/shared/qna/Actions.js